import React from 'react'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import './socials.style.css'

const Social = () => {
  return (
    <div className="headerSocials">
      <a href="https://www.linkedin.com/in/vivekpadelkar/">
        <BsLinkedin />
      </a>
      <a href="https://github.com/vivek-padelkar/">
        <BsGithub />
      </a>
    </div>
  )
}

export default Social
